// extracted by mini-css-extract-plugin
export default {"country":"styles_country__N0eyC","main_section":"styles_main_section__+fdrx","left_banner":"styles_left_banner__rD6m3","right_section":"styles_right_section__9RA6V"};